export var ZoeApiConfigurationRegion;
(function (ZoeApiConfigurationRegion) {
    ZoeApiConfigurationRegion["BARRACUDA"] = "us";
    ZoeApiConfigurationRegion["ORCA"] = "eu";
})(ZoeApiConfigurationRegion || (ZoeApiConfigurationRegion = {}));
